"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragonWhelp_FirePuffAbilityHandler = exports.DragonWhelp_FirePuffActorAbilityFactory = exports.DragonWhelp_FirePuffAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DragonWhelp_FirePuffAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DragonWhelp_FirePuff;
        this.__typeName = "DragonWhelp_FirePuff";
    }
}
exports.DragonWhelp_FirePuffAbilityArgs = DragonWhelp_FirePuffAbilityArgs;
let DragonWhelp_FirePuffActorAbilityFactory = class DragonWhelp_FirePuffActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DragonWhelp_FirePuff", "OneEnemies", 2);
    }
};
DragonWhelp_FirePuffActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DragonWhelp_FirePuff")
], DragonWhelp_FirePuffActorAbilityFactory);
exports.DragonWhelp_FirePuffActorAbilityFactory = DragonWhelp_FirePuffActorAbilityFactory;
let DragonWhelp_FirePuffAbilityHandler = class DragonWhelp_FirePuffAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Fire", 100)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.BurningEffectArgs("Power", 10),
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageImmunity, 10),
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, 10)
                    ], true)
                });
            }
        });
    }
};
DragonWhelp_FirePuffAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DragonWhelp_FirePuff)
], DragonWhelp_FirePuffAbilityHandler);
exports.DragonWhelp_FirePuffAbilityHandler = DragonWhelp_FirePuffAbilityHandler;
